import { compose, withProps } from 'recompose';
import AdminIndustryEdit from './industry-edit';

export default compose(
  withProps(

  )
)(AdminIndustryEdit)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/industry-portal/industry-add.js